var Backbone = bookedby.deps != null ? bookedby.deps.Backbone : global.Backbone;
var _ = bookedby.deps != null ? bookedby.deps._ : global._;
var moment = bookedby.deps != null ? bookedby.deps.moment : global.moment;

// took it from backbone sources
var emailPatternRegExp =  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

function getElement (value, ids) {
  var res = {
    elements: [],
  };
  res.attr = function (prop, val) {
    for (var i = 0; i < res.elements.length; i++) {
      res.elements[i].attr(prop, val);
    }
  };

  for (var i = 0; i < ids.length; i++) {
    var el = $(ids[i]);

    if (el.val() === value
      || (value === null && el.val() === "")
      || (value === "+1" && el.val() === "")
      || (el.val() && ("+1" + (el.val().replace(/\D/g, "")) === value))
      || el.val() !== "" && ("+1" + el.val()) === value) {
      res.elements = res.elements.concat(el);
    }
  }

  return res;
}

function _birthdayValidation(value) {
  var el = getElement(value, ["#birthdayInput", "#profileInforBirthday"]);

  if (value != "" && value != null) {
    var selectedDate = null;
    if (moment(value, 'MM-DD-YYYY', true).isValid()) {
      selectedDate = moment(value, 'MM-DD-YYYY', true);
    } else if (moment(value, 'YYYY-MM-DD', true).isValid()) {
      selectedDate = moment(value, 'YYYY-MM-DD', true);
    } else {
      el.attr("aria-invalid", "true");
      return 'Please enter a birthday as MM-DD-YYYY';
    }

    if (selectedDate.unix() > moment().unix()) {
      el.attr("aria-invalid", "true");
      return 'Please enter a birthday date in the past.';
    }
    if (selectedDate.year() < 1900) {
      el.attr("aria-invalid", "true");
      return 'Please enter a birthday date greater than year 1900.';
    }
    // NOTE: if date of birth greater than now() - 13 years (if younger than 13 yo in simple words)
    if (selectedDate.unix() > moment().subtract('13', 'years').unix()) {
      el.attr("aria-invalid", "true");
      return 'You must be 13 or older to register';
    }
  }

  el.attr("aria-invalid", "false");
}

var ClientModel = Backbone.Epoxy.Model.extend({
  initialize: function() {
    //Birthday validation hack. Have no idea why, but 
    //in some cases when initializing this class (without any pre-stuff) birthday validation become empty object 
    //and we fixing it with this simple reassigment
    if (!this.validation.birthday[0]) this.validation.birthday = [{ fn: _birthdayValidation }];

    Backbone.Validation.bind(this, { liveValidation: true });
  },

  defaults: {
    firstName: null,
    lastName: null,
    fullName: '',
    phone: null,
    phone1: null,
    phone2: null,
    phone3: null,
    gender: null,
    email: null,
    birthday: null,
    zipCode: null,
    cardUuid: null,
    over13backing: false,
    //NOTE:: here we are using the key of the enum as the id and stored value in the model, while the name is used for UI display
    confirmationType: 'Email',
    confirmationTypes: [
      {id: 'Email', name: 'Email'},
      {id: 'SMS', name: 'Text'}
    ],
    password: '',
    passwordConfirm: '',
    loggedIn: false,
    hasLogin: false,
    validationSuspended: true,
    isGuest: false,
    permissions: {},
    routePermissions: {},
    useFullName: false,
    alreadyInQueue: false,
    alreadyInQueueStore: null,
    smsOptIn: true,
    smsMarketingOptIn: false,
    sendConfirmCodeError: false,
    sendConfirmCodeErrorMessage: '',
    skipPasswordValidation: false,
    validateOnlyRequiredPassword: false
  },

  //TODO:: update backbone.validation to remove the requirement below
  //NOTE:: computeds hash must currently always be set on validated epoxy models, even if it is empty...
  computeds: {
    hideSmsMarketingOptIn: {
      deps: ['smsMarketingOptIn', 'origSmsMarketingOptIn'],
      get: function() {
        return this.get('smsMarketingOptIn') && this.get('origSmsMarketingOptIn');
      }
    },
    over13: {
      deps: ['over13backing', 'birthday'],
      get: function(over13backing, birthday) {
        if (birthday != null) {
          var birthdayMoment = null;
          if (moment(birthday, 'MM-DD-YYYY', true).isValid()) {
            birthdayMoment = moment(birthday, 'MM-DD-YYYY', true);
          } else if (moment(birthday, 'YYYY-MM-DD', true).isValid()) {
            birthdayMoment = moment(birthday, 'YYYY-MM-DD', true);
          }

          if (birthdayMoment != null) {
            if (birthdayMoment.unix() > moment().subtract('13', 'years').unix()) {
              return false;
            } else {
              return true;
            }
          }
        }
        return over13backing;
      },
      set: function(value) {
        var birthday = this.get('birthday');
        var birthdayMoment = null;
        if (moment(birthday, 'MM-DD-YYYY', true).isValid()) {
          birthdayMoment = moment(birthday, 'MM-DD-YYYY', true);
        } else if (moment(birthday, 'YYYY-MM-DD', true).isValid()) {
          birthdayMoment = moment(birthday, 'YYYY-MM-DD', true);
        }

        if (value) {
          if (birthdayMoment != null && birthdayMoment.unix() > moment().subtract('13', 'years').unix()) {
            return { over13backing: true, birthday: null };
          } else {
            return { over13backing: true };
          }
        } else {
          if (birthdayMoment != null && birthdayMoment.unix() <= moment().subtract('13', 'years').unix()) {
            return { over13backing: false, birthday: null };
          } else {
            return { over13backing: false };
          }
        }
      }
    },
    birthdayISO: {
      deps: ['birthday'],
      get: function(birthday) {
        if (!birthday) {
          return null;
        }

        var outputFormat = 'YYYY-MM-DD';

        if (typeof(moment) !== 'undefined') {
          if (moment(birthday, 'MM-DD-YYYY', true).isValid()) {
            return moment(birthday, 'MM-DD-YYYY').format(outputFormat);
          } else if (moment(birthday, 'YYYY-MM-DD', true).isValid()) {
            return moment(birthday, 'YYYY-MM-DD').format(outputFormat);
          } else return '';
        } else return '';
      },
      set: function(birthday) {
        if (!birthday) {
          return { birthday: null };
        } else {
          if (moment(birthday, 'YYYY-MM-DD', true).isValid()) {
            return { birthday: moment(birthday, 'YYYY-MM-DD').format('MM-DD-YYYY') };
          } else if(moment(birthday, 'MM-DD-YYYY', true).isValid()) {
            return { birthday: birthday }
          } else {
            return { birthday: moment(birthday, 'YYYY-MM-DD').format('MM-DD-YYYY') };
          }
        }
      }
    },
    fullNameFormat: {
      deps: ['fullName'],
      get: function(fullName) {
        return fullName;
      },
      set: function(fullName) {
        if (_.isEmpty(fullName))
          return { fullName: fullName };

        var fullNameArgs = fullName.split(' ');
        fullNameArgs = _.filter(fullNameArgs, function(args) { return !_.isEmpty(args); });

        return { fullName: fullNameArgs.join(' ') };
      }
    },
    fullName: {
      get: function() {
        var fullName = this.get('_fullName');
        return _.isEmpty(fullName) && this.get('firstName') !== null && this.get('lastName') !== null ? this.get('firstName') + ' ' + this.get('lastName') : fullName
      },
      set: function (value) {
        this.set('_fullName', value);
      }
    }
  },
  validation: {
    firstName: [
      {
        fn: function (value) {
          var el = getElement(value, ["#confirmationFirstName", "#profileInfoFirstName"]);

          if (!value) {
            el.attr("aria-invalid", "true");
            return 'Please enter your first name.';
          }
          if (!/^[A-Za-z\s\-\\']+$/.test(value)) {
            el.attr("aria-invalid", "true");
            return 'Please enter a valid name';
          }
          el.attr("aria-invalid", "false");
        }
      },
    ],

    lastName: [
      {
        fn: function (value) {
          var el = getElement(value, ["#confirmationLastName", "#profileInfoLastName"]);
          if (!value) {
            el.attr("aria-invalid", "true");
            return 'Please enter your last name.';
          }
          if (!/^[A-Za-z\s\-\\']+$/.test(value)) {
            el.attr("aria-invalid", "true");
            return 'Please enter a valid name';
          }
          el.attr("aria-invalid", "false");
        }
      },
    ],

    fullName: [
      // For what this check?! If user is not logged in and it use full name then fail check?! Really strange
      // {
      //   required: function(val, attr, computed) {
      //     return computed.useFullName == true && !(computed.loggedIn);
      //   },
      //   msg: 'Please enter a name.'
      // },
      {
        fn: function() {
          var fullName = this.get('fullName');
          if(!/^[A-Za-z\s\-\\']+$/.test(fullName)) {
            return 'Please enter a valid name.'
          }
        }
      },
      {
        fn: function(value, attr, computed) {
          if (computed.useFullName == true) {
            if (this.get('fullName') && this.get('fullName').trim().split(' ').length <= 1)
              return 'Please enter full name.';
          }
        }
      }
    ],

    phone: [
      {
        fn: function (value) {
          var el = getElement(value, ["#confirmationPhone", "#profileInfoPhone"]);
          if (!value || value === '+1') {
            el.attr("aria-invalid", "true");
            return 'Please enter your phone number';
          }

          var error = bookedby.validations.isValidPhoneNumber(value);
          if (error) {
            el.attr("aria-invalid", "true");
            return error;
          }
          el.attr("aria-invalid", "false");
        },
      },
    ],

    gender: [
      {
        fn: function (value) {
          var el = getElement(value, ["#confirmationGender"]);

          if (!bookedby.staticData.storeGroupSettings.reduceClientNeededInfo && !value) {
            el.attr("aria-invalid", "true");
            return 'Please select your gender'
          }
          el.attr("aria-invalid", "false");
        }
      }
    ],

    email: [
      {
        fn: function (value) {
          var el = getElement(value, ["#emailRegister", "#profileInfoEmail"]);

          if (!value) {
            el.attr("aria-invalid", "true");
            return 'Please enter your email address.';
          } else if (!emailPatternRegExp.test(value)) {
            el.attr("aria-invalid", "true");
            return 'Please enter a valid email address.';
          }

          el.attr("aria-invalid", "false");
        },
      },
    ],

    over13: [
      {
        fn: function() {
          if (!this.get('over13')) {
            return 'You must be 13 or older to register.';
          }
        }
      }
    ],

    birthday: [
      {
        fn: _birthdayValidation
      }
    ],

    zipCode: [
      {
        fn: function (value) {
          var el = getElement(value, ["#zipCode", "#profileInfoZipCode"]);

          var notUs = bookedby.staticData.storeGroupSettings.countryCode &&
            bookedby.staticData.storeGroupSettings.countryCode !== 'US';

          if (value !== null && value !== '') {
            if (notUs) {
              if (!/^[A-Za-z]\d[A-Za-z]$/.test(value)
                && !/^[A-Za-z]\dA-Za-z]\d[A-Za-z]\d$/.test(value)
                && !/^[A-Za-z]\d[A-Za-z]\s?-?\d[A-Za-z]\d$/.test(value)) {
                el.attr("aria-invalid", "true");
                return 'Please enter a valid postal code.'
              }
            } else if (!/^[0-9]{5}$/.test(value)) {
              el.attr("aria-invalid", "true");
              return 'Please enter a valid zip code.'
            }
          } else if (notUs) {
            el.attr("aria-invalid", "true");
            return 'Please enter your postal code.';
          } else {
            el.attr("aria-invalid", "true");
            return 'Please enter your zip code.';
          }
          el.attr("aria-invalid", "false");
        }
      }
    ],

    password: [
      {
        fn: function (value) {
          var el = getElement(value, ["#registerCheckingPasswordInput", "#passwordRegister", "#newPassword"]);
          const password = this.get('password');

          if (!this.get('loggedIn') && !this.get('skipPasswordValidation')) {
            this.get('validateOnlyRequiredPassword')
            const vRes = this.get('validateOnlyRequiredPassword')
              ?global.bookedby.helpers.passwordRequiredValidation(password)
              :global.bookedby.helpers.passwordValidate(password);
            if(!vRes.isValid) {
              el.attr("aria-invalid", "true");
              return vRes.errorMsg;
            }
          }
          el.attr("aria-invalid", "false");
        }
      }
    ],

    passwordConfirm: [
      {
        fn: function (value) {
          var el = getElement(value, ["#registerCheckingConfirmPasswordInput", "#profileInfoPasswordConfirm", "#passwordConfirm", "#newPasswordConfirm"]);

          if (!this.get('loggedIn') && !this.get('skipPasswordValidation')) {
            const passwordConfirm = this.get('passwordConfirm');
            const password = this.get('password');

            const vRes = global.bookedby.helpers.confirmPasswordValidate(passwordConfirm, password);
            if(vRes.isValid) {
              el.attr("aria-invalid", "false");
              return null;
            } else {
              el.attr("aria-invalid", "true");
              return vRes.errorMsg;
            }
          }
          el.attr("aria-invalid", "false");
        }
      }
    ]
  },

  tryClearData: function() {
    if (this.get('loggedIn')) {
      if (this.originalState != null) {
        this.set(this.originalState);
      }
    } else {
      this.set(this.defaults);
    }
  },

  clearValidation: function() {
    this.set('validationSuspended', true);
  },

  saveCurrentState: function() {
    this.originalState = _.clone(this.attributes);
    this.set('origSmsMarketingOptIn', this.get('smsMarketingOptIn'));
  },

  logIn: function(data) {
    this.set(data.client);
    //Logged in clients are over-13 by definition, as they must be in order to register
    this.set('over13backing', true);
    this.set('loggedIn', true);
    this.set('validationSuspended', true);
    //TODO:: get rid of this once we fix the phone thing
    if(this.get('phone1')) {
      this.set('phone', this.get('phone1'));
    } else {
      this.set('phone', this.get('phone'));
    }

    if (!data.client.fullName) {
      this.set('fullName', null);
    }

    this.setPermissions(data.permissions);

    this.saveCurrentState();
  },

  logOut: function(lastLoginEmail) {
    this.originalState = null;
    this.set(this.defaults);
    this.set('id', null);
    if (lastLoginEmail) {
      this.set('email', lastLoginEmail);
    }
  },

  setPermissions: function (permissions) {
    this.permissions = permissions;
  },

  hasPermission: function(section, data) {

    /**
     * Check if needs permission to access this route
     */
    if (_.has(this.routePermissions, section)) {
      /**
       * Check if the user has permission for this section
       */
      if (_.has(this.permissions, section)) {
        var permissionForParam = this.permissions[section];
        /**
         * If user has access and permissions value is null, he is either admin (full access) or this section
         * is not parameter restricted
         */
        if (permissionForParam == null) {
          return true;
        }
        /**
         * If routePermissions value is not null, then this route is restricted by a parameter. Lets check
         * if the user has permission for this parameter.
         */
        var sectionParam = this.routePermissions[section];
        if (sectionParam != null) {
          var tryParam = data[sectionParam];
          return _.contains(permissionForParam, tryParam);
        }

      }
      /**
       * If route is not restricted, return true
       */
    } else {
      return true;
    }
  },

  parseFullName: function() {
    //TODO: Need refactor it. It is really bad when in model one function has different behaviour and update different fields.
    this.set('fullName', this.get('firstName') + ' ' + this.get('lastName'));
  },

  updateFirstAndLastNameFromFullName: function () {
    var fullNameArgs = this.get('fullName').split(' ');
    this.set('firstName', fullNameArgs[0]);
    this.set('lastName', fullNameArgs.slice(1).join(' '));
  },

  getBirthdayStoringFormat: function() {
    if (!this.get('birthday')) {
      return null;
    }

    if (typeof(moment) !== 'undefined') {
      if (moment(this.get('birthday'), 'MM-DD-YYYY', true).isValid()) {
        return moment(this.get('birthday'), 'MM-DD-YYYY').format('YYYY-MM-DD');
      } else if (moment(this.get('birthday'), 'YYYY-MM', true).isValid()) {
        return moment(this.get('birthday'), 'YYYY-MM').format('YYYY-MM-DD');
      } else {
        return moment(this.get('birthday'), 'YYYY-MM-DD').format('YYYY-MM-DD');
      }
    } else return '';
  },

  getConfirmationClientData: function () {
    return {
      firstName: this.get('firstName'),
      lastName: this.get('lastName'),
      email: this.get('email'),
      phone1: this.get('phone'),
      birthDate: this.get('birthday'),
      zipCode: this.get('zipCode'),
      smsOptIn: this.get('smsOptIn'),
      over13backing: this.get('over13backing'),
      smsMarketingOptIn: this.get('smsMarketingOptIn')
    };
  },
  restoreEventsSpecific: _.noop
});

module.exports = ClientModel;
